import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Pay } from '@shared/services/pay';

export const jwtInterceptor: HttpInterceptorFn = (req, next) => {
  const payService = inject(Pay);

  if (payService.token) {
    const authRequest = req.clone({
      headers: req.headers.set('Authorization', `Bearer ${payService.token}`),
    });

    return next(authRequest);
  }
  return next(req);
};
